(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@ecomplus/auth"), require("@ecomplus/utils"), require("axios"), require("@ecomplus/client"));
	else if(typeof define === 'function' && define.amd)
		define([, , , ], factory);
	else if(typeof exports === 'object')
		exports["__ecomplus_marketplace"] = factory(require("@ecomplus/auth"), require("@ecomplus/utils"), require("axios"), require("@ecomplus/client"));
	else
		root["__ecomplus_marketplace"] = factory(root["ecomAuth"], root["ecomUtils"], root["axios"], root["ecomClient"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__4280__, __WEBPACK_EXTERNAL_MODULE__83c4__, __WEBPACK_EXTERNAL_MODULE_cebe__, __WEBPACK_EXTERNAL_MODULE_f27e__) {
return 